import { SessionManager } from "@ark/platform";
import { useSyncExternalStore } from "react";

export const sessionManager = new SessionManager(
  import.meta.env.VITE_API_BASE_URL ?? "http://localhost:18000",
);

export function useSession() {
  return useSyncExternalStore(
    sessionManager.subscribe,
    sessionManager.getSnapshot,
    sessionManager.getSnapshot,
  );
}

export function useSessionReady() {
  return useSyncExternalStore(
    sessionManager.subscribe,
    sessionManager.getReadySnapshot,
    sessionManager.getReadySnapshot,
  );
}
